import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Button } from "@opensea/next-ui-kit";
import { Flex, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { Apple, Google, Outlook, Yahoo } from "@opensea/ui-kit/icons";
import { GoogleCalendar, ICalendar, OutlookCalendar, YahooCalendar } from "datebook";
import { useTranslations } from "next-intl";
import { useShallow } from "zustand/react/shallow";
import { useDropStore } from "@/components/collection/drops/components/CollectionDropContext";
import { useCreateCalendarEvent } from "@/components/collection/drops/use-create-calendar-event";
import { AddToCalendarOptionsFragment } from "./AddToCalendarOptions.fragment";
function CalendarOptionRow(t0) {
  const $ = _c(13);
  const {
    icon,
    title,
    add
  } = t0;
  const t = useTranslations("SetDropReminderModal");
  let t1;
  if ($[0] !== title) {
    t1 = <TextBody size="sm" weight="semibold">{title}</TextBody>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon || $[3] !== t1) {
    t2 = <Flex className="items-center gap-4">{icon}{t1}</Flex>;
    $[2] = icon;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("add");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== add || $[8] !== t3) {
    t4 = <Button onClick={add} size="sm" variant="secondary">{t3}</Button>;
    $[7] = add;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <SpaceBetween>{t2}{t4}</SpaceBetween>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export function AddtoCalendarOptions(t0) {
  const $ = _c(35);
  const {
    drop: dropKey,
    selectedStageIndex
  } = t0;
  const [collectionName, collectionSlug] = useDropStore(useShallow(_temp));
  let t1;
  if ($[0] !== dropKey || $[1] !== selectedStageIndex) {
    const drop = readFragment(AddToCalendarOptionsFragment, dropKey);
    t1 = drop?.stages.find(stage => stage.stageIndex === Number(selectedStageIndex));
    $[0] = dropKey;
    $[1] = selectedStageIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedStage = t1;
  let t2;
  if ($[3] !== collectionName || $[4] !== collectionSlug) {
    t2 = {
      collectionName,
      collectionSlug
    };
    $[3] = collectionName;
    $[4] = collectionSlug;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const createCalendarEvent = useCreateCalendarEvent(t2);
  let t3;
  if ($[6] !== createCalendarEvent || $[7] !== selectedStage) {
    t3 = () => {
      if (!selectedStage) {
        return null;
      }
      const event = createCalendarEvent(selectedStage);
      const calendar = new GoogleCalendar(event);
      window.open(calendar.render(), "_blank");
    };
    $[6] = createCalendarEvent;
    $[7] = selectedStage;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Google />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3) {
    t5 = <CalendarOptionRow add={t3} icon={t4} title="Google Calendar" />;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== createCalendarEvent || $[13] !== selectedStage) {
    t6 = () => {
      if (!selectedStage) {
        return null;
      }
      const event_0 = createCalendarEvent(selectedStage);
      const calendar_0 = new ICalendar(event_0);
      const calendarContent = calendar_0.render();
      window.open(`data:text/calendar;charset=utf-8;base64,${btoa(calendarContent)}`, "_blank");
    };
    $[12] = createCalendarEvent;
    $[13] = selectedStage;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Apple />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6) {
    t8 = <CalendarOptionRow add={t6} icon={t7} title="Apple Calendar" />;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== createCalendarEvent || $[19] !== selectedStage) {
    t9 = () => {
      if (!selectedStage) {
        return null;
      }
      const event_1 = createCalendarEvent(selectedStage);
      const calendar_1 = new OutlookCalendar(event_1);
      window.open(calendar_1.render(), "_blank");
    };
    $[18] = createCalendarEvent;
    $[19] = selectedStage;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Outlook />;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t9) {
    t11 = <CalendarOptionRow add={t9} icon={t10} title="Outlook" />;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== createCalendarEvent || $[25] !== selectedStage) {
    t12 = () => {
      if (!selectedStage) {
        return null;
      }
      const event_2 = createCalendarEvent(selectedStage);
      const calendar_2 = new YahooCalendar(event_2);
      window.open(calendar_2.render(), "_blank");
    };
    $[24] = createCalendarEvent;
    $[25] = selectedStage;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Yahoo />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12) {
    t14 = <CalendarOptionRow add={t12} icon={t13} title="Yahoo calendar" />;
    $[28] = t12;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t11 || $[31] !== t14 || $[32] !== t5 || $[33] !== t8) {
    t15 = <>{t5}{t8}{t11}{t14}</>;
    $[30] = t11;
    $[31] = t14;
    $[32] = t5;
    $[33] = t8;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}
function _temp(state) {
  return [state.collectionName, state.collectionSlug];
}